import { HomeIcon } from './icons';
import { SecondaryLink } from './Buttons';

/**
 * 홈으로 돌아가기 버튼.
 * 모양·크기는 Buttons.tsx 공통 규격을 그대로 쓴다 — 옆에 놓이는 버튼과 높이가 어긋나지 않게.
 * 폭은 부모(ActionStack 등)가 정한다.
 */
export function HomeLink() {
  return (
    <SecondaryLink to="/">
      <HomeIcon className="h-5 w-5" /> 홈으로
    </SecondaryLink>
  );
}
